import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type ImageReferenceId = Branded<string, "ImageReferenceId">;
const { zodSchema: imageReferenceIdZodSchema, assert: isImageReferenceId } =
    genericId<ImageReferenceId>("image_reference__", {
        regexMatch:
            /(^image-reference_.*$)|(^image_reference_.*$)|(^imgref_.*$)/,
    });
const imageReferenceIdFactory = (custom?: `${string}__`) =>
    genericId<ImageReferenceId>(`image_reference__${custom ?? ""}`).factory();

export {
    imageReferenceIdFactory,
    imageReferenceIdZodSchema,
    isImageReferenceId,
};
export type { ImageReferenceId };
